/* @flow */

import type { Action, RootState } from '../types'

import { ActionRequiresPropertyError } from '../helpers'

export const STATE_KEY: string = 'error'

export const SET_ERROR: string = 'opinary/SET_ERROR'
export const UNSET_ERROR: string = 'opinary/UNSET_ERROR'

export function setError(item: Error): Action {
  return {
    type: SET_ERROR,
    item,
  }
}

export function unsetError(): Action {
  return {
    type: UNSET_ERROR,
  }
}

export function selectError(rootState: RootState): ?Error {
  return rootState[STATE_KEY]
}

export default function reducer(state: ?Error = null, action: Object): ?Error {
  switch (action.type) {
    case SET_ERROR:
      if (action.item == null) {
        throw new ActionRequiresPropertyError(SET_ERROR, 'item')
      } else {
        return action.item
      }
    case UNSET_ERROR:
      return null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/error.js